"use strict";
export var AssetType = /* @__PURE__ */ ((AssetType2) => {
  AssetType2["Currency"] = "currency";
  AssetType2["ERC721"] = "erc-721";
  AssetType2["ERC1155"] = "erc-1155";
  return AssetType2;
})(AssetType || {});
